<template>
  <svg
    id="defence"
    version="1.1"
    viewBox="0 0 10 13"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      fill="none"
      fill-rule="evenodd"
      stroke="none"
      stroke-width="1"
    >
      <g
        fill="#0A64FA"
        fill-rule="nonzero"
        transform="translate(-413.000000, -326.000000)"
      >
        <path
          d="M413,327.959039
          L417.999219,326
          L417.999219,326
          L423,327.959039
          L423,327.959039
          L423,333.65916
          C423,336.091973
          417.999219,339
          417.999219,339
          L417.573874,338.738511
          C416.365681,337.971402
          413,335.655314
          413,333.65916
          L413,327.959039
          Z M420.517369,329.648838
          L416.431385,329.648838
          L415.517369,331.11349
          L417.922731,331.11349
          L415.517369,334.648838
          L419.603353,334.648838
          L420.517369,333.184185
          L418.112007,333.184185
          L420.517369,329.648838
          Z"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'DefenceSvg',
}
</script>
